/**
 * AlertFlowSection
 * The "Activity Flow" section card that wraps AlertsStepperFlow.
 */
import React from 'react';
import { FiActivity, FiAlertCircle } from 'react-icons/fi';
import { AlertsStepperFlow } from '@/components/organism/TableExpand/AlertExpanded/AlertsStepperFlow';
import type { ActivityLogEntry } from '@/pages/Alert/alerts.interface';
import { NoDataMessages } from '@/services/alert/alerts.constants';
import {
  SpinnerBlock,
  NoDataPlate,
} from '@/components/organism/TableExpand/primitives';
import { SectionCard } from '@/components/organism/Cards/SectionCard';
import { ORGANISM_PROPS } from '@/constant/global/global.constant';

interface AlertFlowSectionProps {
  loading: boolean;
  isActivityLogDataReceived: boolean;
  activityLog?: ActivityLogEntry[];
  triggeredOn?: string;
  sentClient?: string;
  sentOn?: string;
  createdOn?: string;
  closedOn?: string;
  alertsConfig: any;
  providerData: { partnerUid: string; providerId: string };
  alertType?: string;
  testId?: string;
}

export const AlertFlowSection = ({
  loading,
  isActivityLogDataReceived,
  activityLog,
  triggeredOn,
  sentClient,
  sentOn,
  createdOn,
  closedOn,
  alertsConfig,
  providerData,
  alertType,
  testId,
}: AlertFlowSectionProps) => {
  return (
    <SectionCard
      testId={testId}
      title={ORGANISM_PROPS.ALERT_FLOW_SECTION.TITLE}
      icon={<FiActivity className="h-3.5 w-3.5" />}
      bodyClassName=""
    >
      {loading ? (
        <SpinnerBlock message={ORGANISM_PROPS.ALERT_FLOW_SECTION.LOADING_MSG} />
      ) : !isActivityLogDataReceived ? (
        <NoDataPlate
          message={NoDataMessages.NO_ACTIVITY_LOG_STEPPER}
          icon={<FiAlertCircle className="h-8 w-8" />}
        />
      ) : (
        <AlertsStepperFlow
          triggeredOn={triggeredOn}
          sentClient={sentClient}
          sentOn={sentOn}
          createdOn={createdOn}
          activityLog={activityLog!}
          providerData={providerData}
          alertsConfig={alertsConfig}
          excludedAlertType={alertType}
          closedOn={closedOn}
        />
      )}
    </SectionCard>
  );
};
